





















import { Component, Mixins, Prop } from "vue-property-decorator";
import {
  instanceOfIPatientProfileInformationApplicable,
} from "../../../../../domain/document/items";
import { PatientProfileInformation } from "../../../../../domain/patient";
import { MenuPane } from "../../../../panes";
import { ModelEditableMixin } from "../../../../system/mixins";
import {
  CommonComponentsAccessibleMixin,
  DocumentStructureEditableMixin,
} from "../../mixins";
import { EditingDocument } from "../..";

@Component({
  components: {
    MenuPane,
  }
})
export default class PatientProfileMenu extends Mixins(
  ModelEditableMixin,
  CommonComponentsAccessibleMixin,
  DocumentStructureEditableMixin,
) {
  @Prop({ default: false })
  isHorizontal: boolean;

  editingSource: EditingDocument;
  
  get isVisible(): boolean {
    return this.$configuration.behavior.document.editor.patientProfile.isEditable
      && this.$configuration.behavior.document.editor.patientProfile.isEnable;
  } 
  get isEditable(): boolean {
    return this.readPropertyOrDefault(s => s.isAlreadyInitialized, false);
  }

  edit(): void {
    if (this.editingSource.patientProfile.isInvalid) {
      this.$warn("患者プロフィール", "有効な患者プロフィールではありません。");
      return;
    }
    this.commonComponents.editors.patientProfile.edit();
  }

  get isApplicable(): boolean {
    return instanceOfIPatientProfileInformationApplicable(this.lastFocusedItem);
  }

  apply(): void {
    if (!instanceOfIPatientProfileInformationApplicable(this.lastFocusedItem)) {
      return;
    }
    if (this.editingSource.patientProfile.isInvalid) {
      this.$warn("患者プロフィール", "有効な患者プロフィールではありません。");
      return;
    }
    const patientProfileItem = this.lastFocusedItem.createPatientProfileItem();
    if (!patientProfileItem) {
      return;
    }
    this.writePropertyWhenValid(s => {
      const index = this.findPatientProfileItemIndex(s.patientProfile);
      const isContained = (0 <= index);
      s.patientProfile.items.splice(
        isContained ? index : s.patientProfile.items.length,
        isContained ? 1 : 0,
        patientProfileItem
      );
    });
  }

  private findPatientProfileItemIndex(patientProfile: PatientProfileInformation): number {
    if (!instanceOfIPatientProfileInformationApplicable(this.lastFocusedItem)) { return -1; }
    if (!patientProfile || !patientProfile.items) { return -1; }
    
    // IEがfindIndex対応していない？ので暫定対応
    for (let index = 0; index < patientProfile.items.length; ++index) {
      const item = patientProfile.items[index];
      if (!item) { continue; }
      if (item.name === this.lastFocusedItem.name) { return index; }
    }
    return -1;
  }
  
  get isRemovable(): boolean {
    return this.isApplicable
        && this.readPropertyOrDefault(s => 0 <= this.findPatientProfileItemIndex(s.patientProfile), false);
  }

  remove(): void {
    if (this.editingSource.patientProfile.isInvalid) {
      this.$warn("患者プロフィール", "有効な患者プロフィールではありません。");
      return;
    }
    this.writePropertyWhenValid(s => {
      const index = this.findPatientProfileItemIndex(s.patientProfile);
      s.patientProfile.items.splice(index, 1);
    });
  }

  get className(): string {
    return this.isHorizontal ? "" : "vertical-patient-profile-menu-root";
  }

  get classNameTooltip(): string {
    return this.isHorizontal ? "" : "vertical-patient-profile-menu-tooltip-content";
  }
}
